import { SelectItem } from "@mantine/core";

export const CLIENT_ROUTE = '/notification';
export const API_ROUTE = '/api/notification';
export const CLIENT_TITLE = 'Сонордуулга'

export type APIClient = 'duul' | 'nextgalaxy';

interface APIClientOption extends Omit<SelectItem, 'value'> {
    value: APIClient;
}

export const apiClients: APIClientOption[] = [
    { value: 'duul', label: 'Duul' },
    { value: 'nextgalaxy', label: 'Next Galaxy' },
];